var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 7.82843 13.3284 8.5 12.5 8.5C11.6716 8.5 11 7.82843 11 7C11 6.17157 11.6716 5.5 12.5 5.5C13.3284 5.5 14 6.17157 14 7Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.25C14 13.0784 13.3284 13.75 12.5 13.75C11.6716 13.75 11 13.0784 11 12.25C11 11.4216 11.6716 10.75 12.5 10.75C13.3284 10.75 14 11.4216 14 12.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5C14 18.3284 13.3284 19 12.5 19C11.6716 19 11 18.3284 11 17.5C11 16.6716 11.6716 16 12.5 16C13.3284 16 14 16.6716 14 17.5Z",
    fill: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.5b010b54627ed6633e474fd0d27d54e4.svg";
export { ForwardRef as ReactComponent };